import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button } from '../atoms';

const PopularCourseCard = ({ course, className = "" }) => {
  const { t } = useTranslation();

  return (
    <div className={`bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 ${className}`}>
      {/* Price Badge */}
      <div className="relative p-6 border-b border-gray-100">
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              {course.title}
            </h3>
            <div className="flex items-center gap-4 mb-3">
              <div className="flex items-center gap-2 text-gray-600">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                <span className="text-sm font-medium">{course.duration}</span>
              </div>
              <div className="text-lg font-bold text-orange-600">
                {course.price}
              </div>
            </div>
          </div>
        </div>
        
        <p className="text-gray-600 text-sm leading-relaxed mb-4">
          {course.description}
        </p>

        {/* Visit Spots */}
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-700 mb-2">
            {t('serviceDetail.vipCar.routes.popular.0.spots') ? t('common.visitSpots') : '訪問スポット'}
          </h4>
          <div className="flex flex-wrap gap-2">
            {course.spots.map((spot, index) => (
              <Badge key={index} variant="secondary" className="text-xs">
                {spot}
              </Badge>
            ))}
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="p-6">
        <div className="flex gap-3">
          <Button className="flex-1 bg-orange-600 hover:bg-orange-700 text-white">
            {t('common.bookingApply')}
          </Button>
          <Button variant="outline" className="flex-1 border-gray-300 text-gray-700 hover:bg-gray-50">
            {t('common.inquireDetails')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PopularCourseCard;
